import Splide from '@splidejs/splide';
import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {
    init: function() {
      gsap.registerPlugin( ScrollTrigger );

      $( '.featured-conditions' ).each( function( index, element ) {
        const slider = new Splide( element, {
          type: 'loop',
          perPage: 2,
          perMove: 1,
          pagination: false,
          speed: 800,
          breakpoints: {
            1024: {
              perPage: 2,
            },
            768: {
              perPage: 1,
            },
          },
        } );

        slider.on( 'overflow', function( isOverflow ) {
          slider.options = {
            arrows: isOverflow,
            drag: isOverflow,
            clones: isOverflow ? undefined : 0,
          };
        } );

        slider.mount();

        cardContentPositioning();

        const dividerEl = element.querySelector( '.featured-conditions__divider' );

        if ( dividerEl ) {
          if ( !window.hasMotion ) {
            dividerEl.style.setProperty( '--featured-conditions-divider-scale', 1 );
          } else {
            gsap.set( dividerEl, {
              '--featured-conditions-divider-scale': 0,
            } );

            gsap.to( dividerEl, {
              '--featured-conditions-divider-scale': 1,
              'duration': 1,
              'delay': 0.75,
              'ease': 'power2.out',
              'scrollTrigger': {
                trigger: dividerEl,
                start: 'top 85%',
                once: true,
              },
            } );
          }
        }

        const arrows = element.querySelector( '.featured-conditions__arrows' );

        if ( arrows ) {
          gsap.set( arrows, {
            autoAlpha: 0,
            y: 20,
          } );

          ScrollTrigger.create( {
            trigger: element,
            start: 'top 85%',
            once: true,
            onEnter: () => {
              gsap.to( arrows, {
                autoAlpha: 1,
                y: 0,
                duration: 0.6,
                delay: window.innerWidth >= 1024 ? 1.75 : 0,
                ease: 'power2.out',
              } );
            },
          } );
        }
      } );

      $( window ).on( 'resize', function() {
        cardContentPositioning();
      } );

      function cardContentPositioning() {
        $( '.featured-conditions__card-content' ).each( function() {
          const cardContent = $( this );
          const hoverContent = cardContent.find( '.featured-conditions__hover-content' );

          if ( window.innerWidth > 1024 ) {
            const descriptionHeight = hoverContent.outerHeight();

            cardContent.css( {
              'opacity': '1',
              'transform': `translateY(${descriptionHeight}px)`,
              'transition-duration': window.hasMotion ? '0.5s' : '0s',
            } );
          } else {
            cardContent.css( {
              'opacity': '1',
              'transform': 'translateY(0px)',
              'transition-duration': '',
            } );
          }
        } );
      }
    },
    finalize: function() {},
  };
  app.registerComponent( 'featured-conditions', COMPONENT );
} )( app );
